const s = "/spa/index.css", A = "/app", _ = "val-app", a = "val-overlay", o = !1;
export {
  o as IS_DEV,
  _ as VAL_APP_ID,
  A as VAL_APP_PATH,
  s as VAL_CSS_PATH,
  a as VAL_OVERLAY_ID
};
